import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'success' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  fullWidth = false,
  className = '',
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "bg-primary text-white hover:bg-primary-hover focus:ring-primary-focus border border-transparent",
    secondary: "bg-surface text-text border border-border hover:bg-background focus:ring-gray-200",
    danger: "bg-no text-white hover:bg-red-700 focus:ring-red-500 border border-transparent",
    success: "bg-yes text-white hover:bg-green-700 focus:ring-green-500 border border-transparent",
    outline: "bg-transparent text-primary border border-primary hover:bg-primary/5 focus:ring-primary-focus",
    ghost: "bg-transparent text-muted hover:text-text hover:bg-gray-100 focus:ring-gray-200 border border-transparent"
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-6 py-3 text-lg"
  };

  const widthClass = fullWidth ? "w-full" : "";

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
